import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../lib/constants';
import { trackInitiateCheckout } from '../lib/metaPixel';
type FloatingCTAProps = {
  /** Element id rendered right after the first CTA. The bar appears once it is scrolled past. */
  triggerId: string;
};
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-102" data-mp="38b8la1fqwcls">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-ofm-700/40 bg-ofm-900/95 px-3 pb-[max(0.6rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-sm" data-id="element-103" data-mp="38d1vfqpkheyj">
          <div className="mx-auto flex max-w-xl flex-col items-center gap-1.5" data-id="element-104" data-mp="2pbw6kb90xl5r">
            <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="block w-full rounded-xl bg-gold px-4 py-3.5 text-center text-[14px] font-extrabold leading-tight tracking-tight text-ofm-900 shadow-lg transition-colors hover:bg-[#d9a94e] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:text-base" data-id="element-105" data-mp="2u9xxficoyors">
              🦷 QUIERO EL SISTEMA OFM POR $12.99
            </a>
            <p className="text-[10px] font-medium tracking-wide text-ofm-200 sm:text-[11px]" data-id="element-106" data-mp="4m6rbx4erxcj">
              Pago único • Acceso de por vida • Garantía de 7 días
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}